module.exports = __webpack_public_path__ + "img/IT0004889612364.0fd84599.png";